import services from "@/http";
import { http } from "@/http";
import * as types from "./mutation-types";
import jsonToFormData from "@/helpers/functions/jsonToFormData";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSetFiles", data.data);
  dispatch("ActionSetPagination", data.meta);
};

export const ActionFind = async (store, search) => {
  var files = {
    data: [],
    meta: {},
  };

  await services.files.get_all(search).then((res) => {
    files = res.data;
  });
  return files;
};

export const ActionShow = async ({ dispatch }, id) => {
  await services.files.show({ id: id }).then((res) => {
    dispatch("ActionSetFile", res.data.file);
  });
};

export const ActionSave = async ({ dispatch }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }
};

export const ActionStore = async ({ commit }, payload) => {
  try {
    const formData = jsonToFormData(payload);
    const { data } = await services.files.store(formData);
    // commit(types.SET_FILE, data.file);
    commit(types.PENNDING_FILES, 0);
    return data;
  } catch (error) {
    console.log(error);
    return {};
  }
};

export const ActionSetPendingFilesCount = ({ commit }, payload) => {
  commit(types.PENNDING_FILES, payload);
};

export const ActionUpdate = async ({ commit }, payload) => {
  var formData = jsonToFormData(payload);
  await services.files.update({ id: payload.id }, formData).then((res) => {
    commit(types.SET_FILE, res.data.file);
  });
};

export const ActionDelete = async ({ commit }, id) => {
  await services.files.delete({ id: id }).then(() => {
    commit(types.SET_FILE, null);
  });
};

export const ActionInStorage = async ({ commit }, filename) => {
  try {
    const { data } = await services.files.in_storage({ filename });
    return data;
  } catch (error) {
    return null;
  }
};

export const ActionSetFiles = ({ commit }, payload) => {
  commit(types.SET_FILES, payload);
};

export const ActionSetFile = ({ commit }, payload) => {
  commit(types.SET_FILE, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionNewFile = ({ commit }) => {
  commit(types.SET_FILE, {});
};

export const ActionGetFilesCategoriasToSelect = async ({ commit }) => {
  let response = [
    {
      value: null,
      text: "Selecione",
    },
  ];
  await services.files_categorias.to_select().then((res) => {
    response.push(...res.data);
  });
  return response;
};

export const ActionGetFilesEstrutura = async ({ commit }) => {
  commit(types.SET_LOADING, true);
  await services.files_estruturas.to_select().then((res) => {
    commit(types.SET_ESTRUTURA, res.data);
  });
  commit(types.SET_LOADING, false);
};

export const ActionAddFilesEstrutura = async ({ commit }, payload) => {
  commit(types.SET_LOADING, true);
  await commit(types.ADD_ESTRUTURA, payload);
  commit(types.SET_LOADING, false);
};

export const ActionSaveEstrutura = async ({ dispatch, commit }, payload) => {
  commit(types.SET_LOADING, true);
  if (payload.id) {
    await dispatch("ActionUpdateEstrutura", payload);
  } else {
    await dispatch("ActionStoreEstrutura", payload);
  }
  await dispatch("ActionGetFilesEstrutura");
  commit(types.SET_LOADING, false);
};

export const ActionStoreEstrutura = async ({ commit }, payload) => {
  await services.files_estruturas.store(payload).then((res) => {});
};

export const ActionUpdateEstrutura = async ({ commit }, payload) => {
  await services.files_estruturas
    .update({ id: payload.id }, payload)
    .then((res) => {});
};

export const ActionDeleteFilesEstrutura = async ({ commit, dispatch }, id) => {
  commit(types.SET_LOADING, true);
  await services.files_estruturas.delete({ id: id }).then(() => {});
  await dispatch("ActionGetFilesEstrutura");
  commit(types.SET_LOADING, false);
};

export const ActionsView = async (store, file) => {
  let url = null;
  await http.get(file.url, { responseType: "arraybuffer" }).then((response) => {
    var blob = new Blob([response.body], { type: file.extra_data.type });
    url = window.URL.createObjectURL(blob);
  });
  return url;
};

export const ActionsDownload = async (store, file) => {
  await http.get(file.url, { responseType: "arraybuffer" }).then((response) => {
    var blob = new Blob([response.body], { type: file.extra_data.type });
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = file.extra_data.basename;
    link.click();
  });
};

export const ActionGetImage = async ({ dispatch, getters }, file) => {
  const mime_types = getters.mime_types;

  if (file.mime_type.indexOf("image/") >= 0) {
    const image_file = file.id ? await dispatch("ActionsView", file) : null;
    return image_file;
  }
  let extension = null;
  for (const ext in mime_types) {
    const hasMimeType = mime_types[ext].indexOf(file.mime_type) >= 0;
    if (hasMimeType) {
      extension = ext;
    }
  }

  switch (extension) {
    case "excel":
      return "file-excel";
    case "word":
      return "file-word";
    case "powerpoint":
      return "file-powerpoint";
    case "pdf":
      return "file-pdf";
    default:
      return "file";
  }
};
